"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffsetLeft = exports.getOffsetTop = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var utils_1 = require("@prezzee/utils");
var grow_1 = __importDefault(require("@prezzee/grow"));
var modal_1 = __importDefault(require("@prezzee/modal"));
var paper_1 = __importDefault(require("@prezzee/paper"));
var styled_1 = __importDefault(require("@emotion/styled"));
var style = __importStar(require("./Popover.style"));
function getOffsetTop(rect, vertical) {
    var offset = 0;
    if (typeof vertical === 'number') {
        offset = vertical;
    }
    else if (vertical === 'center') {
        offset = rect.height / 2;
    }
    else if (vertical === 'bottom') {
        offset = rect.height;
    }
    return offset;
}
exports.getOffsetTop = getOffsetTop;
function getOffsetLeft(rect, horizontal) {
    var offset = 0;
    if (typeof horizontal === 'number') {
        offset = horizontal;
    }
    else if (horizontal === 'center') {
        offset = rect.width / 2;
    }
    else if (horizontal === 'right') {
        offset = rect.width;
    }
    return offset;
}
exports.getOffsetLeft = getOffsetLeft;
function getTransformOriginValue(transformOrigin) {
    return [transformOrigin.horizontal, transformOrigin.vertical]
        .map(function (n) { return (typeof n === 'number' ? "".concat(n, "px") : n); })
        .join(' ');
}
function resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var PopoverPaper = (0, styled_1.default)(paper_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), style.paper);
var Popover = React.forwardRef(function (props, ref) {
    var action = props.action, anchorEl = props.anchorEl, _a = props.anchorOrigin, anchorOrigin = _a === void 0 ? {
        vertical: 'top',
        horizontal: 'left',
    } : _a, anchorPosition = props.anchorPosition, _b = props.anchorReference, anchorReference = _b === void 0 ? 'anchorEl' : _b, children = props.children, className = props.className, containerProp = props.container, _c = props.elevation, elevation = _c === void 0 ? 'sm' : _c, _d = props.marginThreshold, marginThreshold = _d === void 0 ? 16 : _d, open = props.open, _e = props.PaperProps, PaperProps = _e === void 0 ? {} : _e, _f = props.transformOrigin, transformOrigin = _f === void 0 ? {
        vertical: 'top',
        horizontal: 'left',
    } : _f, _g = props.TransitionComponent, TransitionComponent = _g === void 0 ? grow_1.default : _g, _h = props.transitionDuration, transitionDurationProp = _h === void 0 ? 'auto' : _h, _j = props.TransitionProps, _k = _j === void 0 ? {} : _j, onEntering = _k.onEntering, TransitionProps = __rest(_k, ["onEntering"]), other = __rest(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
    var paperRef = React.useRef();
    // @ts-ignore
    var handlePaperRef = (0, utils_1.useForkRef)(paperRef, PaperProps.ref);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    var getAnchorOffset = React.useCallback(function () {
        if (anchorReference === 'anchorPosition') {
            if (process.env.NODE_ENV !== 'production') {
                if (!anchorPosition) {
                    console.error('You need to provide a `anchorPosition` prop when using ' +
                        '<Popover anchorReference="anchorPosition" />.');
                }
            }
            return anchorPosition;
        }
        var resolvedAnchorEl = resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1
            ? resolvedAnchorEl
            : (0, utils_1.ownerDocument)(paperRef.current).body;
        var anchorRect = anchorElement.getBoundingClientRect();
        if (process.env.NODE_ENV !== 'production') {
            var box = anchorElement.getBoundingClientRect();
            if (process.env.NODE_ENV !== 'test' &&
                box.top === 0 &&
                box.left === 0 &&
                box.right === 0 &&
                box.bottom === 0) {
                console.warn([
                    'The `anchorEl` prop provided to the component is invalid.',
                    'The anchor element should be part of the document layout.',
                    "Make sure the element is present in the document or that it's not display none.",
                ].join('\n'));
            }
        }
        return {
            top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal),
        };
    }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]);
    // Returns the base transform origin using the element
    var getTransformOrigin = React.useCallback(function (elemRect) {
        return {
            vertical: getOffsetTop(elemRect, transformOrigin.vertical),
            horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal),
        };
    }, [transformOrigin.horizontal, transformOrigin.vertical]);
    var getPositioningStyle = React.useCallback(function (element) {
        var elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight,
        };
        // Get the transform origin point on the element itself
        var elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') {
            return {
                top: null,
                left: null,
                transformOrigin: getTransformOriginValue(elemTransformOrigin),
            };
        }
        // Get the offset of the anchoring element
        var anchorOffset = getAnchorOffset();
        // Calculate element positioning
        var top = (anchorOffset === null || anchorOffset === void 0 ? void 0 : anchorOffset.top) - elemTransformOrigin.vertical;
        var left = (anchorOffset === null || anchorOffset === void 0 ? void 0 : anchorOffset.left) - elemTransformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        var containerWindow = (0, utils_1.ownerWindow)(resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        var heightThreshold = containerWindow.innerHeight - marginThreshold;
        var widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            var diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        else if (bottom > heightThreshold) {
            var diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        if (process.env.NODE_ENV !== 'production') {
            if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
                console.error([
                    'The popover component is too tall.',
                    "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."),
                    'Please consider adding a `max-height` to improve the user-experience.',
                ].join('\n'));
            }
        }
        // Check if the horizontal axis needs shifting
        if (left < marginThreshold) {
            var diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        else if (right > widthThreshold) {
            var diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: "".concat(Math.round(top), "px"),
            left: "".concat(Math.round(left), "px"),
            transformOrigin: getTransformOriginValue(elemTransformOrigin),
        };
    }, [anchorEl, anchorReference, getAnchorOffset, getTransformOrigin, marginThreshold]);
    var setPositioningStyles = React.useCallback(function () {
        var element = paperRef.current;
        if (!element) {
            return;
        }
        var positioning = getPositioningStyle(element);
        if (positioning.top !== null) {
            element.style.top = positioning.top;
        }
        if (positioning.left !== null) {
            element.style.left = positioning.left;
        }
        element.style.transformOrigin = positioning.transformOrigin;
    }, [getPositioningStyle]);
    var handleEntering = function (element, isAppearing) {
        if (onEntering) {
            onEntering(element, isAppearing);
        }
        setPositioningStyles();
    };
    React.useEffect(function () {
        if (open) {
            setPositioningStyles();
        }
    });
    React.useImperativeHandle(action, function () {
        return open
            ? {
                updatePosition: function () {
                    setPositioningStyles();
                },
            }
            : null;
    }, [open, setPositioningStyles]);
    React.useEffect(function () {
        if (!open) {
            return undefined;
        }
        var handleResize = (0, utils_1.debounce)(function () {
            setPositioningStyles();
        });
        var containerWindow = (0, utils_1.ownerWindow)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return function () {
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [anchorEl, open, setPositioningStyles]);
    var transitionDuration = transitionDurationProp;
    // @ts-ignore
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
        // @ts-ignore
        transitionDuration = undefined;
    }
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    var container = containerProp || (anchorEl ? (0, utils_1.ownerDocument)(resolveAnchorEl(anchorEl)).body : undefined);
    return ((0, jsx_runtime_1.jsx)(modal_1.default
    // @ts-ignore
    , __assign({ 
        // @ts-ignore
        BackdropProps: { invisible: true }, className: className, container: container, open: open, ref: ref }, other, { children: (0, jsx_runtime_1.jsx)(TransitionComponent, __assign({ appear: true, in: open, onEntering: handleEntering, timeout: transitionDuration }, TransitionProps, { children: (0, jsx_runtime_1.jsx)(PopoverPaper, __assign({ elevation: elevation }, PaperProps, { 
                // @ts-ignore
                ref: handlePaperRef, className: PaperProps.className }, { children: children })) })) })));
});
exports.default = Popover;
var templateObject_1;
//# sourceMappingURL=Popover.js.map